import GenericService from 'services/genericService';
import {
	ContactUsSelfcareData,
	RetrieveOsmIncidentData,
	RetrieveOsmInteractionData,
	DirectMessageData,
} from 'utils/api/payloads/omantelApi';
import {
	contactUsSelfcare,
	retrieveOsmIncident,
	retrieveOsmInteraction,
	sendDirectMessage,
} from 'utils/api/queries/omantelApi';
import { getTopics } from 'utils/api/queries/wcm';
import { Observable } from 'rxjs';
import { TroubleTicketingCategories } from 'utils/api/models/troubleTicketing/categories';
import { Incident } from 'utils/api/models/troubleTicketing/incident';
import { Interaction } from 'utils/api/models/troubleTicketing/interaction';
import { Tickets } from 'utils/api/models/tickets/ticktes';
import { createOsmInteraction, getTickets } from 'utils/api/queries/microApi';

export class ContactService extends GenericService {
	public static send(data: ContactUsSelfcareData) {
		return contactUsSelfcare(data)
			.withErrorHandling()
			.call();
	}

	public static sendDirectMessage(data: DirectMessageData) {
		return sendDirectMessage(data)
			.withErrorHandling()
			.call();
	}

	public static retrieveOsmIncident(data: RetrieveOsmIncidentData): Observable<Incident> {
		return retrieveOsmIncident(data).call();
	}

	public static retrieveOsmInteraction(data: RetrieveOsmInteractionData): Observable<Interaction> {
		return retrieveOsmInteraction(data).call();
	}

	public static createOsmInteraction(data: any) {
		return createOsmInteraction(data).call();
	}

	public static getTopics(): Observable<TroubleTicketingCategories> {
		return getTopics()
			.withErrorHandling()
			.call();
	}

	public static getTickets(upId: number | null): Observable<Tickets> {
		return getTickets(upId)
			.withErrorHandling()
			.call();
	}
}
